/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';
import {ServiceLocaleLanguage} from './ServiceLocaleLanguage';

/**
 * The ServiceListLocaleLanguagesResponse model module.
 * @module model/ServiceListLocaleLanguagesResponse
 * @version version not set
 */
export class ServiceListLocaleLanguagesResponse {
  /**
   * Constructs a new <code>ServiceListLocaleLanguagesResponse</code>.
   * @alias module:model/ServiceListLocaleLanguagesResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceListLocaleLanguagesResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceListLocaleLanguagesResponse} obj Optional instance to populate.
   * @return {module:model/ServiceListLocaleLanguagesResponse} The populated <code>ServiceListLocaleLanguagesResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceListLocaleLanguagesResponse();
      if (data.hasOwnProperty('data'))
        obj.data = ApiClient.convertToType(data['data'], [ServiceLocaleLanguage]);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/ServiceLocaleLanguage>} data
 */
ServiceListLocaleLanguagesResponse.prototype.data = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceListLocaleLanguagesResponse.prototype.state = undefined;


